<template>
  <div id="app">
    <!-- 路由占位符 -->
    <router-view class="main" ></router-view>
  </div>
</template>

<script>
export default {
	name:'app',
	data() {
		return{
		            	lastTime: null, // 鼠标最后一次点击时间
			            currentTime: null, // 当前时间
						//10小时
			            sys_timeout: 600 * 60 * 1000, // 系统安全时间
			            check_time: 30 * 1000, //探测间隔时间
			            timer: null,  // 定时器

		}
	},
  async mounted(){
//await this.$store.dispatch('getUserInfoActions')
 this.dtrouter()
  this.currentTime = new Date().getTime();
         this.lastTime = new Date().getTime();
         // 监听鼠标点击时间，获取最后一次点击时间
         window.document.onmousedown = (event) => {
          // console.log('重置最后一次点击时间');
           this.lastTime = new Date().getTime();
         }
         this.onload(); 

  },
   destroyed() {
          clearInterval(this.timer)
      },
 created(){
	},
	methods:{
		  // 间隔特定时间检测系统无操作时间
		        onload() {
		          this.timer = window.setInterval(this.checkTimeOut, this.check_time)
		        },
		        // 判断系统无操作时间是否大于安全时间
		        checkTimeOut() {
		          this.currentTime = new Date().getTime();
		          if(this.currentTime - this.lastTime > this.sys_timeout) {
		                // todo 退出登录
					//console.log('执行退出登录操作！')	
					this.$router.push('/login')
					window.sessionStorage.clear()
					location.reload();
					this.$store.commit('updateUserInfo',{})
					this.$store.commit('updateMenu',[])
						
		          }
		        }

  }
}
</script>

<style lang="scss">
    @import 'assets/style/index.scss';
		#app{
		   width: 100%;
		           height: 100%;
		           margin: 0;
		           padding: 0;
		
		}
   
    .main{
      width: 100%;
      height: 100%;
	  //禁止横向滚动
	  overflow-x: hidden;
    }
</style>
